import { useInvoiceByIdQuery } from "@/gqlhooks/invoice/useInvoiceByIdQuery";
import { InvoiceDetailScreen } from "./InvoiceDetail.screen";
import { useInvoiceState } from "@/store/invoices";
import { useWindowDimensions } from "@/components/hooks/use-window-dimension";
import { PaymentMethodScreenModal } from "@/types/invoice";
import { useRoute } from "@/components/shared/router";
import { useEffect } from "react";
import { ApplyVoucherModal } from "../apply-voucher-modal";
import { useSegments } from "@/components/hooks/use-segments";
import { getPlatform } from "@/lib/utils";

type InvoiceDetailContainerProps = {
  invoiceId: string;
};

export const InvoiceDetailContainer = ({
  invoiceId,
}: InvoiceDetailContainerProps) => {
  const segments = useSegments();

  const { invoice, loading, refetch } = useInvoiceByIdQuery(invoiceId);

  const { push } = useRoute();

  const { setInvoiceId, showPaymentMethodModal, setInvoiceDepartments } =
    useInvoiceState();

  const { isMobile } = useWindowDimensions();

  const showVoucherModal = useInvoiceState(
    (state) => state.data.showVoucherModal,
  );

  useEffect(() => {
    if (invoice.id) {
      setInvoiceId(invoice.id);
    }
  }, [invoice.id]);

  const handlePay = () => {
    setInvoiceId(invoiceId);
    showPaymentMethodModal(PaymentMethodScreenModal.SELECT_PAYMENT);
    setInvoiceDepartments(invoice.departments ?? []);

    if (isMobile) {
      push({ pageKey: "selectPayment" });
    }
  };

  const isRouteInvoiceDetail =
    segments.includes("invoices") &&
    segments.includes("profile") &&
    getPlatform() !== "web";

  return (
    <>
      <InvoiceDetailScreen
        invoice={invoice}
        loading={loading}
        refetch={refetch}
        handlePay={handlePay}
      />
      <ApplyVoucherModal
        invoice={invoice}
        open={showVoucherModal && isRouteInvoiceDetail}
      />
    </>
  );
};
